module.exports = __webpack_public_path__ + "img/0S6A9488.ca0fb5a8.jpg";